export default "__VITE_ASSET__BQSgHaZ6__"